import { usePreferencesStore } from '@/store/preferencesStore';

/**
 * Returns the transparent text logo for the sidebar and mobile top bar.
 */
export function useThemeLogo(): string {
  const brand = usePreferencesStore((s) => s.brand);
  return brand === 'blue' ? '/logo-text-transparent-blue.png' : '/logo-text-transparent-green.png';
}

/**
 * Returns the square logo with background for auth screens (login, register).
 */
export function useThemeFullLogo(): string {
  const brand = usePreferencesStore((s) => s.brand);
  return brand === 'blue' ? '/logo-blue.jpeg' : '/logo-full.jpeg';
}
